var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"past-alerts-table-container"}},[_c('div',{staticClass:"pa-header"},[_vm._v(" Past Alerts ")]),_c('div',{staticClass:"pa-container"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.pastAlertsData.restAlertList,"hide-default-footer":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }